import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';

import { BYOCWrapper, FEaaSWrapper } from '@sitecore-jss/sitecore-jss-nextjs';

import * as Accordion from 'src/components/Sections/Accordion/Accordion';
import * as AlertMessage from 'src/components/Generic/AlertMessage';
import * as ArticleActionBar from 'src/components/Pages/ArticleParts/ArticleActionBar';
import * as ArticleBody from 'src/components/Pages/ArticleParts/ArticleBody/ArticleBody';
import * as ArticleBottomContainer from 'src/components/Pages/ArticleParts/ArticleBottomContainer';
import * as ArticleCards from 'src/components/Pages/ArticleListings/ArticleCards';
import * as ArticleChapters from 'src/components/Pages/ArticleParts/ArticleChapters';
import * as ArticleFilterBar from 'src/components/Pages/ArticleListings/ArticleFilterBar';
import * as ArticleFootnote from 'src/components/Pages/ArticleParts/ArticleFootnote';
import * as ArticleHero from 'src/components/Sections/Banners/ArticleHero/ArticleHero';
import * as ArticleInfogramTile from 'src/components/Pages/ArticleParts/ArticleInfogramTile';
import * as ArticleSeriesBanner from 'src/components/Sections/ArticleSeriesBanner';
import * as ArticleSeriesCollection from 'src/components/Sections/ArticleSeriesCollection';
import * as ArticleSubscriptionBanner from 'src/components/Pages/ArticleParts/ArticleSubscriptionBanner';
import * as ArticleTiles from 'src/components/Pages/ArticleParts/ArticleTiles';
import * as AutomaticDocumentListings from 'src/components/Sections/AutomaticDocumentListings';
import * as AwardsBanner from 'src/components/Sections/AwardsBanner';
import * as BannerQuickLinks from 'src/components/Blocks/BannerQuickLinks';
import * as BaseHeading from 'src/components/Generic/BaseHeading';
import * as Breadcrumbs from 'src/components/Generic/Breadcrumbs';
import * as CallOutSection from 'src/components/Sections/CallOutSection';
import * as CallToAction from 'src/components/CallToAction';
import * as ContainerMain from 'src/components/Generic/Containers/ContainerMain';
import * as CustomerReviewTile from 'src/components/Tiles/CustomerReviewTile';
import * as CustomerReviewsSection from 'src/components/Sections/CustomerReviewsSection';
import * as DescriptiveHighlightSection from 'src/components/Sections/DescriptiveHighlightSection';
import * as DocumentListings from 'src/components/Sections/DocumentListings';
import * as DynamicRelatedArticlesSection from 'src/components/Pages/FundsCenter/AllFunds/DynamicRelatedArticlesSection';
import * as EloquaForm from 'src/components/Sections/EloquaForm/EloquaForm';
import * as FeaturedArticlesSection from 'src/components/Sections/RelatedArticlesVariations/FeaturedArticlesSection';
import * as FeaturedThemeSection from 'src/components/Sections/RelatedArticlesVariations/FeaturedThemeSection';
import * as FeatureBanner from 'src/components/Sections/Banners/FeatureBanner';
import * as FilteredArticleCards from 'src/components/Pages/ArticleListings/FilteredArticleCards';
import * as Footer from 'src/components/Generic/Footer';
import * as FundCentreMainTabs from 'src/components/Pages/FundsCenter/AllFunds/FundCentreMainTabs';
import * as FundDetailsBanner from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsBanner';
import * as FundDetailsImportantInfo from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsImportantInfo';
import * as FundDetailsTabs from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsTabs';
import * as FundInFocus from 'src/components/Tiles/FundInFocus';
import * as FundsInFocus from 'src/components/Pages/Funds/FundsInFocus';
import * as GatedAccordionContainer from 'src/components/Sections/Accordion/GatedAccordionContainer';
import * as Header from 'src/components/Generic/Header/Header';
import * as Heading from 'src/components/Pages/ArticleParts/Heading';
import * as HelpArticleBody from 'src/components/Pages/ArticleParts/HelpArticleBody';
import * as HelpArticleHero from 'src/components/Sections/Banners/HelpArticleHero';
import * as HelpNextSteps from 'src/components/Pages/ArticleParts/HelpNextSteps';
import * as HighlightBlock from 'src/components/Pages/ArticleParts/TextBlocks/HighlightBlock';
import * as HighlightSection from 'src/components/Sections/HighlightSection';
import * as IFrame from 'src/components/Blocks/IFrame';
import * as Image from 'src/components/Generic/SitecoreWrappers/Image';
import * as Infographics from 'src/components/Blocks/Infographics';
import * as IntroCopy from 'src/components/Generic/IntroCopy';
import * as InvestmentsHero from 'src/components/Sections/Banners/InvestmentsHero';
import * as KeyHighlights from 'src/components/Pages/ArticleParts/KeyHighlights';
import * as KidsTable from 'src/components/Pages/KidsHub/KidsTable/KidsTable';
import * as LanguageSelector from 'src/components/Generic/Header/LanguageSelector';
import * as LatestArticlesSection from 'src/components/Sections/RelatedArticlesVariations/LatestArticlesSection';
import * as LatestPressReleasesSection from 'src/components/Sections/LatestPressReleasesSection';
import * as Link from 'src/components/Pages/ArticleParts/TextBlocks/Link';
import * as List from 'src/components/Pages/ArticleParts/TextBlocks/List';
import * as ListingHeroSection from 'src/components/Sections/Banners/ListingHeroSection';
import * as LiteratureHub from 'src/components/Pages/LiteratureHub/LiteratureHub';
import * as LogoTextBlocks from 'src/components/Sections/LogoTextBlocks';
import * as MediaBlock from 'src/components/Sections/MediaBlock';
import * as MegaNavigation from 'src/components/Generic/Header/MegaNavigation/MegaNavigation';
import * as NextSteps from 'src/components/Pages/ArticleParts/NextSteps';
import * as PageLevelTabs from 'src/components/Sections/PageLevelTabs';
import * as Paragraph from 'src/components/Pages/ArticleParts/TextBlocks/Paragraph';
import * as Podcast from 'src/components/Pages/ArticleParts/Podcast';
import * as PremiumArticleEloquaForm from 'src/components/Pages/ArticleParts/PremiumArticleEloquaForm';
import * as PressReleaseBody from 'src/components/Pages/PressReleases/PressReleaseBody';
import * as PressReleaseCards from 'src/components/Pages/PressReleases/PressReleaseCards';
import * as PressReleaseFilterBar from 'src/components/Pages/PressReleases/PressReleaseFilterBar';
import * as PressReleaseHero from 'src/components/Sections/PressReleaseHero';
import * as PricingSummary from 'src/components/Pages/Funds/PricingSummary';
import * as PrimaryHeroBanner from 'src/components/Sections/Banners/PrimaryHeroBanner';
import * as PropertyListingCards from 'src/components/Sections/Listings/PropertyListingCards';
import * as Quote from 'src/components/Pages/ArticleParts/Quote';
import * as QuotationBlocks from 'src/components/Sections/QuotationBlocks';
import * as RecentArticles from 'src/components/Sections/RecentArticles';
import * as RelatedArticlesSection from 'src/components/Sections/RelatedArticlesVariations/RelatedArticlesSection';
import * as RelatedCapabilities from 'src/components/Pages/ArticleParts/RelatedCapabilities';
import * as RelatedHelpPlatform from 'src/components/Pages/ArticleParts/RelatedHelpPlatform';
import * as RelatedStories from 'src/components/Pages/ArticleParts/RelatedStories';
import * as RelatedTaggedHelp from 'src/components/Pages/ArticleParts/RelatedTaggedHelp';
import * as RichText from 'src/components/Generic/SitecoreWrappers/RichText';
import * as RiskWarning from 'src/components/Sections/RiskWarning/RiskWarning';
import * as Rows from 'src/components/Sections/EloquaForm/Rows';
import * as SalesforceIntegratedForm from 'src/components/Generic/Forms/SalesforceIntegratedForms/SalesforceIntegratedForm';
import * as SecondaryHeroBanner from 'src/components/Sections/Banners/SecondaryHeroBanner';
import * as SectionHeading from 'src/components/Sections/SectionHeading';
import * as SectionSelector from 'src/components/Sections/SectionSelector';
import * as SeriesArticles from 'src/components/Sections/SeriesArticles';
import * as ShareScreen from 'src/components/Generic/ShareScreen';
import * as Showcase from 'src/components/Sections/Showcase';
import * as SideTile from 'src/components/Sections/Tiles/SideTile';
import * as SocialNetwork from 'src/components/includes/SocialNetwork';
import * as SpotifyPodcast from 'src/components/Pages/ArticleParts/SpotifyPodcast';
import * as StickyCta from 'src/components/Sections/StickyCta';
import * as StrategyInFocus from 'src/components/Pages/FundsCenter/StrategyInFocus';
import * as TableOfContents from 'src/components/Sections/TableOfContents/TableOfContents';
import * as TeamListingCards from 'src/components/TeamListingCards';
import * as TeamMemberBiography from 'src/components/Sections/TeamMemberBiography/TeamMemberBiography';
import * as TeamProfileCards from 'src/components/Sections/TeamProfileCards';
import * as TeamProfileCardsWithImages from 'src/components/Sections/TeamProfileCardsWithImages';
import * as TertieryHeroBanner from 'src/components/Sections/Banners/TertieryHeroBanner';
import * as TextBlocks from 'src/components/Pages/ArticleParts/TextBlocks/TextBlocks';
import * as Tile from 'src/components/Sections/Tiles/Tile';
import * as Tiles from 'src/components/Sections/Tiles';
import * as TrustFinder from 'src/components/Pages/TrustFinder/TrustFinder';
import * as VectorTile from 'src/components/Tiles/VectorTile';
import * as Video from 'src/components/Pages/ArticleParts/Video';
import * as AutomatedFundsLiteratureAccordion from 'src/components/Pages/AutomatedFundsLiteratureAccordion';
import * as MorningstarDataFeed from 'src/components/MorningstarDataFeed';
import * as TrustArticleHero from 'src/components/Sections/Banners/TrustArticleHero';
import * as FundDetailsPreliminaryImportantInfo from 'src/components/Pages/FundsCenter/FundDetails/FundDetailsPreliminaryImportantInfo';

export const components = new Map();
components.set('BYOCWrapper', BYOCWrapper);
components.set('FEaaSWrapper', FEaaSWrapper);

components.set('Accordion', Accordion);
components.set('AlertMessage', AlertMessage);
components.set('ArticleActionBar', ArticleActionBar);
components.set('ArticleBody', ArticleBody);
components.set('ArticleBottomContainer', ArticleBottomContainer);
components.set('ArticleCards', ArticleCards);
components.set('ArticleChapters', ArticleChapters);
components.set('ArticleFilterBar', ArticleFilterBar);
components.set('ArticleFootnote', ArticleFootnote);
components.set('ArticleHero', ArticleHero);
components.set('ArticleInfogramTile', ArticleInfogramTile);
components.set('ArticleSeriesBanner', ArticleSeriesBanner);
components.set('ArticleSeriesCollection', ArticleSeriesCollection);
components.set('ArticleSubscriptionBanner', ArticleSubscriptionBanner);
components.set('ArticleTiles', ArticleTiles);
components.set('AutomaticDocumentListings', AutomaticDocumentListings);
components.set('AwardsBanner', AwardsBanner);
components.set('BannerQuickLinks', BannerQuickLinks);
components.set('BaseHeading', BaseHeading);
components.set('Breadcrumbs', Breadcrumbs);
components.set('CallOutSection', CallOutSection);
components.set('CallToAction', CallToAction);
components.set('ContainerMain', ContainerMain);
components.set('CustomerReviewTile', CustomerReviewTile);
components.set('CustomerReviewsSection', CustomerReviewsSection);
components.set('DescriptiveHighlightSection', DescriptiveHighlightSection);
components.set('DocumentListings', DocumentListings);
components.set('DynamicRelatedArticlesSection', DynamicRelatedArticlesSection);
components.set('EloquaForm', EloquaForm);
components.set('FeaturedArticlesSection', FeaturedArticlesSection);
components.set('FeaturedThemeSection', FeaturedThemeSection);
components.set('FeatureBanner', FeatureBanner);
components.set('FilteredArticleCards', FilteredArticleCards);
components.set('Footer', Footer);
components.set('FundCentreMainTabs', FundCentreMainTabs);
components.set('FundDetailsBanner', FundDetailsBanner);
components.set('FundDetailsImportantInfo', FundDetailsImportantInfo);
components.set('FundDetailsTabs', FundDetailsTabs);
components.set('FundInFocus', FundInFocus);
components.set('FundsInFocus', FundsInFocus);
components.set('GatedAccordionContainer', GatedAccordionContainer);
components.set('Header', Header);
components.set('Heading', Heading);
components.set('HelpArticleBody', HelpArticleBody);
components.set('HelpArticleHero', HelpArticleHero);
components.set('HelpNextSteps', HelpNextSteps);
components.set('HighlightBlock', HighlightBlock);
components.set('HighlightSection', HighlightSection);
components.set('IFrame', IFrame);
components.set('Image', Image);
components.set('Infographics', Infographics);
components.set('IntroCopy', IntroCopy);
components.set('InvestmentsHero', InvestmentsHero);
components.set('KeyHighlights', KeyHighlights);
components.set('KidsTable', KidsTable);
components.set('LanguageSelector', LanguageSelector);
components.set('LatestArticlesSection', LatestArticlesSection);
components.set('LatestPressReleasesSection', LatestPressReleasesSection);
components.set('Link', Link);
components.set('List', List);
components.set('ListingHeroSection', ListingHeroSection);
components.set('LiteratureHub', LiteratureHub);
components.set('LogoTextBlocks', LogoTextBlocks);
components.set('MediaBlock', MediaBlock);
components.set('MegaNavigation', MegaNavigation);
components.set('NextSteps', NextSteps);
components.set('PageLevelTabs', PageLevelTabs);
components.set('Paragraph', Paragraph);
components.set('Podcast', Podcast);
components.set('PremiumArticleEloquaForm', PremiumArticleEloquaForm);
components.set('PressReleaseBody', PressReleaseBody);
components.set('PressReleaseCards', PressReleaseCards);
components.set('PressReleaseFilterBar', PressReleaseFilterBar);
components.set('PressReleaseHero', PressReleaseHero);
components.set('PricingSummary', PricingSummary);
components.set('PrimaryHeroBanner', PrimaryHeroBanner);
components.set('PropertyListingCards', PropertyListingCards);
components.set('Quote', Quote);
components.set('QuotationBlocks', QuotationBlocks);
components.set('RecentArticles', RecentArticles);
components.set('RelatedArticlesSection', RelatedArticlesSection);
components.set('RelatedCapabilities', RelatedCapabilities);
components.set('RelatedHelpPlatform', RelatedHelpPlatform);
components.set('RelatedStories', RelatedStories);
components.set('RelatedTaggedHelp', RelatedTaggedHelp);
components.set('RichText', RichText);
components.set('RiskWarning', RiskWarning);
components.set('Row', Rows);
components.set('SalesforceIntegratedForm', SalesforceIntegratedForm);
components.set('SecondaryHeroBanner', SecondaryHeroBanner);
components.set('SectionHeading', SectionHeading);
components.set('SectionSelector', SectionSelector);
components.set('SeriesArticles', SeriesArticles);
components.set('ShareScreen', ShareScreen);
components.set('Showcase', Showcase);
components.set('SideTile', SideTile);
components.set('SocialNetwork', SocialNetwork);
components.set('SpotifyPodcast', SpotifyPodcast);
components.set('StickyCta', StickyCta);
components.set('StrategyInFocus', StrategyInFocus);
components.set('TableOfContents', TableOfContents);
components.set('TeamListingCards', TeamListingCards);
components.set('TeamMemberBiography', TeamMemberBiography);
components.set('TeamProfileCards', TeamProfileCards);
components.set('TeamProfileCardsWithImages', TeamProfileCardsWithImages);
components.set('TertieryHeroBanner', TertieryHeroBanner);
components.set('TextBlocks', TextBlocks);
components.set('Tile', Tile);
components.set('Tiles', Tiles);
components.set('TrustFinder', TrustFinder);
components.set('VectorTile', VectorTile);
components.set('Video', Video);
components.set('Automated Funds Literature Accordion', AutomatedFundsLiteratureAccordion);
components.set('MorningstarDataFeed', MorningstarDataFeed);
components.set('TrustArticleHero', TrustArticleHero);
components.set('FundDetailsPreliminaryImportantInfo', FundDetailsPreliminaryImportantInfo);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
